import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { reauthenticateWithCredential, EmailAuthProvider, updatePassword } from 'firebase/auth';
import Logo from '../images/school_logo.png';
import Back from '../images/back2.webp';
import '../styles/PersonalInformation.css';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';

const ChangePassword = () => {
  const { user } = useUserAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState({
    current: false,
    new: false,
    confirm: false
  });
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    loadImage(Back).then(() => setLoading(false));
  }, []);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      setShowModal(true);
      return;
    }
    if (!user) return;

    setUpdate(true);

    try {
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      setUpdate(false);
      setSuccessMessage("Password updated successfully.");
      setShowModal(true);
    } catch (error) {
      setUpdate(false);      
      setError("Failed to update password. Please check your current password and try again..");
      setShowModal(true);
    }
  };

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  if (loading) {
    return <Loader text={"LOADING"}/>;
  }

  return (
    <>
      {update && <Loader text={"UPDATING"} />}
      <div className="top-elements row align-center space-between">
        <Link to="/home" className="back-link"><i className="fa-solid fa-arrow-left size3"></i></Link>      
        <div className="column align-center justify-center">           
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}><i className="fa-solid fa-rotate-right size4"></i></Link>
      </div>
      <div className="login-page-items column align-center" style={{backgroundImage: `url(${Back})`}}>
        <div className="form-items">          
          <p className="login-heading align-center justify-center">CHANGE PASSWORD</p>                    
          <form onSubmit={handlePasswordChange}>
            <div style={{ 
              position: 'relative', 
              width: '100%',
              display: 'inline',
              marginBottom: '15px'
            }}>         
              <input
                className="input-field"
                type={passwordVisibility.current ? 'text' : 'password'}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Current Password"
                style={{
                  paddingRight: '35px',
                  width: '100%'
                }}
              />
            </div>

            <div style={{ 
              position: 'relative', 
              display: 'inline',
              width: '100%',
              marginBottom: '15px'
            }}>
              <input
                className="input-field"
                type={passwordVisibility.new ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="New Password"
                style={{
                  paddingRight: '35px',
                  width: '100%'
                }}
              />
              <span
                onClick={() => togglePasswordVisibility('new')}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                <i className={passwordVisibility.new ? `fa-solid fa-eye-slash` : `fa-solid fa-eye`}></i>
              </span>
            </div>

            <div style={{ 
              position: 'relative', 
              // display: 'inline',
              width: '100%',
              marginBottom: '15px'
            }}>
              <input
                className="input-field"
                type={passwordVisibility.confirm ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm Password"
                style={{
                  paddingRight: '35px',
                  width: '100%'
                }}
              />
              <span
                onClick={() => togglePasswordVisibility('confirm')}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '35%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                <i className={passwordVisibility.confirm ? `fa-solid fa-eye-slash` : `fa-solid fa-eye`}></i>
              </span>
            </div>

            <button type="submit" className="login-button">UPDATE PASSWORD</button>
          </form>
        </div>
      </div>
      {showModal && (
        <SuccessModal
          icon={error ? "xmark" : "check"}
          iconColor={error ? "red" : "green"}
          message={error || successMessage}
          onClose={() => {
            setError("");
            setSuccessMessage("");
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default ChangePassword;